import { render, staticRenderFns } from "./mydormApply.vue?vue&type=template&id=85914cae&scoped=true"
import script from "./mydormApply.vue?vue&type=script&lang=js"
export * from "./mydormApply.vue?vue&type=script&lang=js"
import style0 from "./mydormApply.vue?vue&type=style&index=0&id=85914cae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85914cae",
  null
  
)

export default component.exports